import React from "react";
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import styles from "assets/jss/material-dashboard-react/views/homeStyle.js";

const useStyles = makeStyles(styles);

export default function Home() {
    const classes = useStyles();

    return (
        <Grid
            container
            spacing={0}
            align="center"
            justify="center"
            direction="column"
            className={classes.gridContainer}
        >
            <Grid item className={classes.titleGridItem}>
                <h1 className={classes.title}>Vodafone&nbsp;&nbsp;Business&nbsp;&nbsp;Center</h1>
            </Grid>
            <Grid item className={classes.loginGridItem}>
                <h4><Link to="/login" className={classes.loginLink}>Login Here</Link></h4>
            </Grid>
        </Grid>
    );
}